/**
 * @fileoverview DELETE handler for the "/apps/multi_language_settings/delete_locale/:locale_id" endpoint
 */
import fetch from "@lib/fetch";

import {
  createMutationFetcherFunctionWithShadowError,
  reactQueryMutationAdapter,
} from "../reactQueryFetcherAdapters";
import { appsMultiLanguageSettingsDeleteLocaleLocaleIdCacheKeys } from "./constants";
import type {
  AppsMultiLanguageSettingsDeleteLocaleLocaleIdProps,
  AppsMultiLanguageSettingsDeleteLocaleLocaleIdResult,
  DeleteLocaleErrors,
} from "./types";

export const deleteAppsMultiLanguageSettingsDeleteLocaleLocaleId = reactQueryMutationAdapter(
  appsMultiLanguageSettingsDeleteLocaleLocaleIdCacheKeys,
  createMutationFetcherFunctionWithShadowError<DeleteLocaleErrors>()(
    (
      props: AppsMultiLanguageSettingsDeleteLocaleLocaleIdProps
    ): Promise<AppsMultiLanguageSettingsDeleteLocaleLocaleIdResult> => {
      return fetch(`/apps/multi_language_settings/delete_locale/${props.localeId}`, "DELETE", {}, undefined, {
        propagateFetchRequestError: false,
      });
    }
  )
);
